import {
  CREATE_POJOK_EDUKASI_SUCCESS,
  CREATE_POJOK_EDUKASI_FAIL,
  RETRIEVE_POJOK_EDUKASI_SUCCESS,
  RETRIEVE_POJOK_EDUKASI_FAIL,
  UPDATE_POJOK_EDUKASI_SUCCESS,
  UPDATE_POJOK_EDUKASI_FAIL,
  DELETE_POJOK_EDUKASI_SUCCESS,
  DELETE_POJOK_EDUKASI_FAIL,
} from "../actions/types";

const initialState = {
  items: [],
  totalPages: 0,
  currentPage: 1,
  totalItems: 0,
};

function Reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_POJOK_EDUKASI_SUCCESS:
      return { ...state, items: [...state.items, payload] };

    case RETRIEVE_POJOK_EDUKASI_SUCCESS:
      return {
        items: payload.data,
        totalPages: payload.totalPages,
        currentPage: payload.currentPage,
        totalItems: payload.totalItems,
      };

    case RETRIEVE_POJOK_EDUKASI_FAIL:
      return { ...state };

    case UPDATE_POJOK_EDUKASI_SUCCESS:
      return {
        ...state,
        items: state.items.map((data) => {
          if (data.uuid === payload.uuid) {
            return {
              ...data,
              ...payload,
            };
          } else {
            return data;
          }
        }),
      };

    case DELETE_POJOK_EDUKASI_SUCCESS:
      return {
        ...state,
        items: state.items.filter(({ uuid }) => uuid !== payload.uuid),
      };

    default:
      return state;
  }
}

export default Reducer;
